import React, { useContext, useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useUser } from '../../../../hooks/useUser' 
import { AppContext } from "../../../../providers/appProvider"
import ErrorModal from '../../../UI/ErrorModal/ErrorModal';
import Pagination from '../../../UI/Pagination/Pagination';  
import UserDeleteModal from '../Delete/Delete';
import UserEditModal from '../Edit/Edit';
import AddUserModal from '../Add/Add';
import UserPassModal from '../Password/Password';
import tbl from '../../../../assets/Style/Table.module.css'
import { useUpdateEffect } from '../../../../hooks/useUpdateEffect';
import cl from './UserList.module.css'
import { useAuth } from '../../../../providers/authProvider';
import { useMessage } from '../../../../hooks/useMessage';
import SendMessageModal from '../SendMessageModal/SendMessageModal';
import SendBulkModal from '../SendBulkModal/SendBulkModal';
import { useTranslation } from 'react-i18next'; 
import RoleLanguage from '../../../UI/RoleLanguage/RoleLanguage';  


const UserList = () => {
  const {t} = useTranslation();
  
  const { roleId } = useParams()
  const {appState, app} = useContext(AppContext);
  const canShowUsers = app.hasPermission("USER_PAGE_SHOW");
  const canRegisterOwnDealer = app.hasPermission("USER_DEALER_REGISTER_OWN") && !canShowUsers;
  const dealerRoleId = appState.roles.find(role => role.name === "dealer")?.id || 0;
  const roleIdInt = canRegisterOwnDealer ? dealerRoleId : (parseInt(roleId, 10) || 0);
   
  const { messageService } = useMessage(-1);

  const { userService } = useUser(50, true, roleIdInt);

  useEffect(() => {
     userService.setFilter({
      ...userService.filter,
      ['role_id']: roleIdInt
    });
  }, [roleId, roleIdInt]);


  const {isRole} = useAuth(AppContext) 
  const auth = useAuth()

   
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    userService.setFilter({
      ...userService.filter,
      [name]: value,
      page: 1,
    });
  };


  function timeSince(dateString) {
    const date = new Date(dateString);
    const now = new Date(Date.now());
    const seconds = Math.floor((now - date) / 1000);
  
    if (seconds < 90) {
      return <div className={cl.online}>Online</div>;
    }
  
    let interval = seconds / 3600;
    if (interval > 1) {
      if (interval < 24) {
        return Math.floor(interval) + ' ' + t('HoursAgo');
      } else {
        const days = Math.floor(interval / 24);  
        return days + ' ' + t('DaysAgo');  
      }
    }
  
    interval = seconds / 60;
    if (interval >= 1) {
      return Math.floor(interval)  + ' ' + t('MinutesAgo');  
    }
  
    return Math.floor(seconds)  + ' ' + t('SecondsAgo'); 
  }

  const formatDate = (dateString) => {
      const createdAtDate = new Date(dateString);

      const months = [t('Jan'), t('Feb'), t('Mar'), t('Apr'), t('May'), t('Jun'), t('Jul'), t('Aug'), t('Sep'), t('Oct'), t('Nov'), t('Dec')];


      const day = createdAtDate.getDate();
      const month = months[createdAtDate.getMonth()];
      const year = createdAtDate.getFullYear();
      const hours = createdAtDate.getHours().toString().padStart(2, '0'); // Pad with a zero if single-digit
      const minutes = createdAtDate.getMinutes().toString().padStart(2, '0'); // Pad with a zero if single-digit

      return `${day} ${month} ${year} ${hours}:${minutes}`; 
  };


  const loginViaUser = async (userId) => { 
    try {
      const response = await userService.loginAsUser(userId);
      auth.loginVia(response);
    } catch (error) {
      console.error(error);
      if (app && app.setError) {
        app.setError('Unable to login as selected user');
      }
    }
  };

  return <div>

    <div className={ cl.headMain }> 
        <h1>{t('Users')}</h1> 

        <div style={{ display: 'flex' , gap: '10px'}}>

          { app.hasPermission("SEND_BULK_MESSAGE") &&  
            <SendBulkModal  userService={userService}  /> 
          }

          { (app.hasPermission("USER_ADD") || canRegisterOwnDealer) &&
            <AddUserModal  userService={userService}  /> 
          }

        </div>
        
    </div>
  
      
    <div className={tbl.table + ' ' + cl.table}>

      <table>
          <thead>
              <tr>
                  <th className={cl.id} >#</th>

                  <th className={ cl.pad0 }>
                    <input name="firstname"  placeholder={t('Firstname') +' ' + t('Lastname')} value={userService.filter.firstname} onChange={handleInputChange} /> 
                  </th>

                  <th className={ cl.pad0 }>
                    <input name="email" placeholder={t('Email')} value={userService.filter.email}  onChange={handleInputChange} />
                  </th>

                  <th className={ cl.pad0 }>
                    <input  name="mobile" placeholder={t('Mobile')} value={userService.filter.mobile} onChange={handleInputChange} />
                  </th>
                  
                  <th className={ cl.pad0 }>
                    <input name="personal" placeholder={t('PersonalNumber')} value={userService.filter.personal}  onChange={handleInputChange} />
                  </th>
                  
                  <th>{t('Saler')}</th>
                  <th>{t('Role')}</th>
                  <th>{t('Level')}</th> 
                  <th>{t('Status')}</th> 
                  <th>{t('CreatedAt')}</th>  
                  { app.hasPermission("USER_SALARY_SHOW") &&   
                    <> 
                      <th>{t('Salary')}</th>  
                      <th>{t('Bonus')}</th>  
                      <th>Max {t('Bonus')}</th>   
                    </>
                  }
               
                  <th> </th> 
              </tr>
          </thead>
          <tbody> 
            {userService.items.map((user) =>
                <tr key={user.id}    >
                  <td className={cl.id} >{user.id} </td>
                  <td>
                    {user.firstname}  {user.lastname} 
                    {user.companyName} 

                  </td>
                  <td>{user.email}</td>
                  <td>{user.mobile}</td>
                  <td>
                    {user.personal}   
                    {user.companyIdentifier}   

                    {user.id_front ? (
                      <a href={user.id_front} target="_blank" rel="noopener noreferrer"> {t('Front')} </a>
                    ) : null}

                    {user.id_back ? (
                      <a href={user.id_back} target="_blank" rel="noopener noreferrer"> {t('Back')} </a>
                    ) : null} 

                  </td>
                  <td>
                  {user && user.saler && user.saler.firstname && user.saler.lastname && (
                    <>
                      {user.saler.firstname} {user.saler.lastname}
                    </>
                    )}        
                  </td> 
                  <td>
                      <RoleLanguage role={user?.role?.description} />

                  </td>
                  <td>{user.level}</td>
                  <td>{timeSince(user.seen)} </td> 

                  <td>{formatDate(user.created_at)} </td> 
                  { app.hasPermission("USER_SALARY_SHOW") &&   
                    <>
                        <td> {(user.salary)}₾</td> 
                        <td> {(user.bonus_percent)}%</td> 
                        <td> {(user.bonus_max_percent)}%</td> 
                        </>
                  }
                        <td className={ cl.btntbl }>
                   

                    <div className={ cl.btns }>



                      { app.hasPermission("USER_EDIT") && 
                        <UserEditModal userService={userService} defaultUser={user} />   
                      }

                    { app.hasPermission("SEND_ONE_MESSAGE") && 

                      <SendMessageModal messageService={messageService} mobile={user.mobile} ></SendMessageModal>
                    }
                      
                      { app.hasPermission("USER_PASSWORD_CHANGE") && 
                      <UserPassModal userService={userService} defaultUser={user} />  
                      }

                      { (auth.isRole('superadmin')) && (
                        <button onClick={() => loginViaUser(user.id)} className={cl.loginBtn}>
                          {t('Login')}
                        </button>
                      )}

                      { app.hasPermission("USER_DELETE") && 
                      <UserDeleteModal userService={userService} defaultUser={user} /> 
                      }
                    </div>
                  </td>
                </tr>  
              )}
          </tbody>
      </table>
 
      </div>



   {appState.error && <ErrorModal message={appState.error} onClose={() => app.clearError(false)} />}

    <Pagination 
      total={userService.total} 
        perPage={userService.filter.limit} 
        current={userService.filter.page} 
        paginate={(page) => {
            userService.setFilter({
            ...userService.filter,
            page: page,
          });
        }}
        setLimit={(limit) => {
            userService.setFilter({
            ...userService.filter,
            limit: limit,
          });
        }}
    />
  </div>;
}

export default UserList;
